<div class="cpcontent">

    <div class="row">
        <div class="col-md-6">
            <h4 *ngIf="user == null">New User</h4>
            <h4 *ngIf="user != null && user.id.length > 0">Edit User</h4>
            Id: {{user?.id}}<br><br>

            <div class="row">
                <div class="col-md-6">
                    <div class="vspace">
                        <sa-input-text [id]="'userName'" [(text)]="user.userName" [title]="'Email'" [required]="'text'"></sa-input-text>
                    </div>
                    <div class="vspace">
                        <sa-input-text [id]="'firstName'" [(text)]="user.firstName" [title]="'First Name'" [required]="'text'"></sa-input-text>
                    </div>
                    <div class="vspace">
                        <sa-select [TagId]="'organizationId'" [(Id)]="user.organizationId" [title]="'Organization'" [options]="organizations"></sa-select>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="vspace">
                        <sa-input-text [id]="'phone'" [(text)]="user.phone" [title]="'Phone'" [required]="'none'"></sa-input-text>
                    </div>
                    <div class="vspace">
                        <sa-input-text [id]="'lastName'" [(text)]="user.lastName" [title]="'Last Name'" [required]="'text'"></sa-input-text>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <div class="vspace">
                        <sa-input-text [id]="'password'" *ngIf="user.id.length < 1" [(text)]="user.password" [title]="'Password'" [required]="'text'"></sa-input-text>
                    </div>
                </div>
                <div class="col-md-6">
                    <div class="vspace">
                        <sa-input-text [id]="'passwordverify'" *ngIf="user.id.length < 1" [(text)]="passwordverify" [title]="'Verify Password'" [required]="'text'"></sa-input-text>
                    </div>
                </div>
            </div>
            <button id="submit" class="btn btn-primary btn-sm" (click)="submit()">Submit</button>
            <button id="delete" class="btn btn-warning btn-sm" style="float:right" (click)="delete()">Delete</button>
        </div>
        <div class="col-md-2" *ngIf="user.id.length > 0">
            <h4>Reset password</h4>
            <div class="vspace">
                <sa-input-text [(text)]="resetpassword1" [title]="'Password'" [required]="'text'"></sa-input-text>
            </div>
            <div class="vspace">
                <sa-input-text [(text)]="resetpassword2" [title]="'Verify Password'" [required]="'text'"></sa-input-text>
            </div>
            <button class="btn btn-primary btn-sm" (click)="changePassword()">Change Password</button>
        </div>
        <div class="col-md-4" *ngIf="user.id.length > 0">
            <h4>Roles</h4>

            <sa-select style="display:inline-block;margin-right:10px" [(Id)]="roleid" [title]="'Role'" [options]="roles"></sa-select>
            <button class="btn btn-primary btn-sm" (click)="addRole()">Add Selected Role</button>
            <br /><br />
            <table class="table">
                <tr *ngFor="let r of userroles">
                    <td>{{r}}</td>
                    <td><button class="btn btn-warning btn-sm" (click)="removeRole(r)">Delete</button></td>
                </tr>
            </table>
        </div>
    </div>

    <br>
    <div class="row">
        <div class="col-md-3">
            <sa-input-text [(text)]="organization.name" [title]="'Name'" [required]="'none'"></sa-input-text>
            <sa-input-text [(text)]="organization.abreviation" [title]="'Abbreviation'" [required]="'none'"></sa-input-text>
            <button id="submit" class="btn btn-primary btn-sm" (click)="submitWithOrg()">Submit with new Org</button>
        </div>
        <div class="col-md-3">
            <sa-input-text [(text)]="beaconName1" [title]="'Beacon 1'" [required]="'none'" ></sa-input-text>
            <sa-input-text [(text)]="beaconName2" [title]="'Beacon 2'" [required]="'none'" ></sa-input-text>
            <sa-input-text [(text)]="beaconName3" [title]="'Beacon 3'" [required]="'none'" ></sa-input-text>
            <button id="submit" class="btn btn-primary btn-sm" (click)="assignBeacon()">Assign Beacon</button>
        </div>
    </div>
    <div hidden="hidden">
        {{user | json}}
        To do's:<br>
        <ul>
            <li>Protect roles with admin</li>
            <li>Protect Authenticate</li>
            <li>Get roles for getallusers</li>
            <li>Rename removeuserfromrole to removerolefromuser</li>
            <li>Get regex for password</li>
            <li>Validate usercreation form and passwordchange form</li>
            <li>IMplement try/catch in api where applicable</li>
            <li>Update query of updateuserinfo to body</li>
            <li>AddRoleToUser should use id and not string UserEmail</li>
        </ul>
    </div>
</div>